import { lazy } from "react";
//users
const LoginScreen = lazy(() => import("../../views/users/auth/LoginScreen"));
// const RegisterScreen = lazy(() => import("../../views/administrador/auth/RegisterScreen"));
const ForgotMyPassword = lazy(() =>
    import("../../views/users/auth/ForgotMyPassword")
);
const PasswordReset = lazy(() =>
    import("../../views/users/auth/PasswordReset")
);

//teachers
const LoginTeachersScreen = lazy(() =>
    import("../../views/users/auth/Teachers/LoginScreen")
);
const ForgotMyPasswordTeacher = lazy(() =>
    import("../../views/users/auth/Teachers/ForgotMyPassword")
);
const PasswordResetTeacher = lazy(() =>
    import("../../views/users/auth/Teachers/PasswordReset")
);

//students
const LoginStudentsScreen = lazy(() =>
    import("../../views/users/auth/Students/LoginScreen")
);
const ForgotMyPasswordStudents = lazy(() =>
    import("../../views/users/auth/Students/ForgotMyPassword")
);
const PasswordResetStudents = lazy(() =>
    import("../../views/users/auth/Students/PasswordReset")
);

const AdmissionApplication = lazy(() =>
    import("../../views/students/AdmissionApplication")
);

const AcademicEventCall = lazy(() =>
    import("../../views/students/AcademicEventCall")
);

const EventParticipation = lazy(() =>
    import("../../views/students/EventParticipation")
);

const AdmissionApplicationSucces = lazy(() =>
    import("../../views/students/AdmissionApplicationSuccesScreen")
);

export const LogOutRouter = {
    LoginScreen,
    ForgotMyPassword,
    PasswordReset,

    LoginTeachersScreen,
    ForgotMyPasswordTeacher,
    PasswordResetTeacher,

    LoginStudentsScreen,
    ForgotMyPasswordStudents,
    PasswordResetStudents,
    AdmissionApplication,
    AcademicEventCall,
    EventParticipation,
    AdmissionApplicationSucces,
};
